import React from 'react';
import { CheckboxField } from '@wk/components-v3-react16';
import { ValidatedFieldAtoms } from '../../formAtoms';
import { useValidatedField } from '../../formHooks';

interface CheckboxInputFieldProps {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldAtoms: ValidatedFieldAtoms<any, any>;
  helperText?: string;
  indicator?: 'required' | 'none';
  label: string;
}

export const CheckboxInputField: React.FC<CheckboxInputFieldProps> = ({
  disabled = false,
  fieldAtoms,
  helperText,
  indicator = 'none',
  label,
}) => {
  const { error, handleBlur, handleChange, showError, value } =
    useValidatedField(fieldAtoms);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event.target.checked);
  };

  const fieldId = `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div>
      <CheckboxField indicator={indicator} label={label} labelFor={fieldId}>
        <input
          checked={value || false}
          data-testid={`Field-${fieldId}`}
          disabled={disabled}
          flow-id="checkbox"
          id={fieldId}
          onBlur={handleBlur}
          onChange={handleCheckboxChange}
          type="checkbox"
        />
      </CheckboxField>
      {showError && error && (
        <div
          style={{
            color: 'var(--color-error, #d32f2f)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
      {!showError && helperText && (
        <div
          style={{
            color: 'var(--color-text-secondary, #666)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};
